export function isSearchPath(url: string): boolean {
  return Boolean(url?.match(/^\/search($|[/?].*$)/));
}

